<template>
  <aside class="mb-20">
    <h2 class="h4 box-pad-5">Sua Reserva</h2>
    <ul class="border-blue box-list list-unstyled clearfix size-14 weight-lighter">

      <!-- DAILY -->
      <li
        v-for="(charge, index) in diariaCharges"
        :key="`diaria-${index}`"
        class="box-list-item border-bottom clearfix">
        {{ charge.description }}
        <span
          v-if="charge.unit_name && charge.unit_name === 'Day'"
          class="size-11">
          {{ charge.quantity ? charge.quantity + 'x' : '1x' }} {{ charge.unit_value | brlPrice }}
        </span>
        <span class="pull-right weight-bold">{{ charge.amount | brlPrice }}</span>
      </li>

      <!-- COVERAGES -->
      <li
          v-if="coveragesList.length"
          class="box-list-item clearfix border-bottom"
          style="margin-top: 14px">
        <strong class="size-11">Coberturas</strong>
      </li>

      <li
        v-for="(charge, index) in coveragesList"
        :key="`coverage-${index}`"
        :class="{ 'border-bottom': index < (coveragesList.length - 1) }"
        class="box-list-item clearfix">
        {{ charge.description }}
        <span class="size-11">
          {{ charge.quantity ? charge.quantity + 'x' : '1x' }} {{ charge.unit_value | brlPrice }}
        </span>
        <span class="pull-right weight-bold">{{ charge.amount | brlPrice }}</span>
      </li>

      <!-- OPTIONALS -->
      <li
        v-if="safeOptionals.length"
        class="box-list-item clearfix border-bottom">
        <strong class="size-11">Opcionais</strong>
      </li>
      <li
        v-for="(optional, index) in safeOptionals"
        :key="`optional-${index}`"
        :class="{ 'border-bottom': index < (safeOptionals.length - 1) }"
        class="box-list-item clearfix">
        {{ optional.name }}
        <span class="size-11">
          {{ optional.charge.quantity + 'x' }} {{ optional.charge.unit_value | brlPrice }}
        </span>
        <span class="pull-right weight-bold">{{ optional.charge.amount | brlPrice }}</span>
      </li>

      <!-- TAXES -->
      <li
        v-if="taxes.length"
        class="box-list-item clearfix border-bottom">
        <strong class="size-11">Taxas</strong>
      </li>
      <li
        v-for="(tax, index) in taxes"
        :key="`tax-${index}`"
        :class="{ 'border-bottom': index < (taxes.length - 1) }"
        class="box-list-item clearfix">
        {{ tax.description }}
        <span
          v-if="tax.unit_name && tax.unit_name === 'Day'"
          class="size-11">
          {{ tax.quantity ? tax.quantity + 'x' : '1x' }} {{ tax.unit_value | brlPrice }}
        </span>
        <span class="pull-right weight-bold">{{ tax.amount | brlPrice }}</span>
      </li>

    </ul>
    <br>
    <span class="btn-gray btn-block btn-extra-large clearfix">
      <span class="pull-left">Total</span>
      <span class="pull-right">{{ total | brlPrice }}</span>
    </span>

  </aside>
</template>

<script>
export default {
  props: [
    'dailyRate',
    'charges',
    'optionals',
    'coverages',
  ],
  methods: {
    normalizeDescription (str) {
      if (!str) return '';
      return String(str).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase();
    }
  },
  computed: {
    safeOptionals () {
      return this.optionals || [];
    },

    normalizedCharges () {
      return (this.charges || []).map(ch => {
        const descRaw = (ch && ch.description) ? String(ch.description) : '';
        const normalized = this.normalizeDescription(descRaw);
        return { ...ch, normalizedDescription: normalized };
      });
    },
    diariaCharges () {
      return this.nonTaxCharges.filter(ch => ch.normalizedDescription.includes('DIARIA'));
    },
    coveragesList () {
      return this.nonTaxCharges.filter(ch => !ch.normalizedDescription.includes('DIARIA'));
    },
    taxes () {
      return this.normalizedCharges.filter(ch => ch.normalizedDescription.includes('TAXA'));
    },
    nonTaxCharges() {
      return this.normalizedCharges.filter(ch => !ch.normalizedDescription.includes('TAXA'));
    },
    optionalsAmount () {
      return this.safeOptionals.map(optional => Number((optional.charge && optional.charge.amount) || 0));
    },
    total () {
      const chargesAmounts = (this.charges || []).map(ch => Number(ch.amount || 0));
      return [
        ...chargesAmounts,
        ...this.optionalsAmount
      ].reduce((memo, num) => (memo + num), 0);
    }
  }
};
</script>
